import * as firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
// import 'firebase/auth';
import 'firebase/firestore';
import firebaseConfig from '../../configs/firebaseConfig';
import store from '@/store';
import moment from 'moment-timezone';

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
let unsubscribeTodoSnapshot = null;
let unsubscribeTodoCategorySnapshot = null;

export default {
    db,
    initFirebaseUI(cb) {
        const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

        ui.start('#firebaseui-auth-container', {
            credentialHelper: firebaseui.auth.CredentialHelper.NONE,
            signInOptions: [
                firebase.auth.EmailAuthProvider.PROVIDER_ID,
                // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                // firebase.auth.GithubAuthProvider.PROVIDER_ID,
            ],
            signInSuccessUrl: '/schedule',
            callbacks: {
                signInSuccessWithAuthResult: () => {
                    cb();
                },
            },
        });
    },
    authUser() {
        return new Promise((resolve, reject) => {
            auth.onAuthStateChanged(
                user => {
                    if (!user) {
                        store.commit('clearUser');
                        reject('no user data');
                        return;
                    }

                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                    const uid = user.uid;
                    const payload = {
                        email: user.email,
                        level: 3,
                        name: user.displayName,
                        uid,
                        photoURL: user.photoURL,
                        providerData: user.providerData,
                    };
                    store.commit('setUser', payload);

                    // Set todos
                    this.todos.fetchTodos();
                    this.todos.fetchCategory();

                    resolve(user);
                },
                error => {
                    store.commit('clearUser');
                    reject(error);
                }
            );
        });
    },
    signout() {
        auth.signOut().then(function() {
            // Sign-out successful.
            store.commit('clearUser');
        });
    },
    todos: {
        fetchCategory() {
            if (unsubscribeTodoCategorySnapshot) {
                unsubscribeTodoCategorySnapshot();
            }

            // realtime updates from our posts collection
            let userId = store.state.user.uid;

            unsubscribeTodoCategorySnapshot = db
                .collection('user')
                .doc(userId)
                .collection('categories')
                .where('deleted_at', '==', null)
                .onSnapshot(querySnapshot => {
                    let categoryList = [];
                    querySnapshot.forEach(doc => {
                        let post = doc.data();
                        post.id = doc.id;
                        categoryList.push(post);
                    });

                    categoryList.sort((a, b) => a.order - b.order);
                    store.commit('setCategories', categoryList);
                });
        },
        addCategory(title) {
            const userId = store.state.user.uid;
            const order = store.state.todos.categories.length;

            // Add new task
            db.collection('user')
                .doc(userId)
                .collection('categories')
                .doc()
                .set({
                    title,
                    order,
                    created_at: new Date(),
                    updated_at: null,
                    deleted_at: null,
                });
        },
        updateCategoryName(id, title) {
            db.collection('user')
                .doc(store.state.user.uid)
                .collection('categories')
                .doc(id)
                .update({
                    title,
                    updated_at: new Date(),
                });
        },
        deleteCategory(id) {
            db.collection('user')
                .doc(store.state.user.uid)
                .collection('categories')
                .doc(id)
                .update({
                    deleted_at: new Date(),
                });
        },
        fetchTodos() {
            if (unsubscribeTodoSnapshot) {
                unsubscribeTodoSnapshot();
            }
            // Set todos
            // realtime updates from our posts collection
            const userId = store.state.user.uid;
            const start = moment(store.state.todos.start)
                .tz('America/New_York')
                .startOf('day')
                .toDate();
            const end = moment(store.state.todos.end)
                .tz('America/New_York')
                .endOf('day')
                .toDate();
            // Get category
            const selectedCategory = store.state.todos.selectedCategory;
            let categoryDocRef = null;
            if (selectedCategory) {
                categoryDocRef = db
                    .collection('user')
                    .doc(userId)
                    .collection('categories')
                    .doc(selectedCategory);
            }

            const todoList = db
                .collection('user')
                .doc(userId)
                .collection('todos')
                .where('current_date', '>=', start)
                .where('current_date', '<=', end)
                .where('deleted_at', '==', null)
                .where('category', '==', categoryDocRef);

            unsubscribeTodoSnapshot = todoList.onSnapshot(querySnapshot => {
                let todoList = [];

                querySnapshot.forEach(doc => {
                    let post = doc.data();
                    post.id = doc.id;
                    todoList.push(post);
                });

                todoList = todoList
                    .map(x => {
                        var t = new Date(1970, 0, 1);
                        t.setSeconds(x.current_date.seconds);

                        x['currentDateNumber'] = moment(end).format('yyyyMMDD');
                        // parseInt(
                        //     moment(x.current_date.toDate())
                        //         .local()
                        //         .format('yyyyMMDD')
                        // );
                        return x;
                    })
                    .sort((a, b) => a.order - b.order)
                    .sort((a, b) => a.currentDateNumber - b.currentDateNumber);

                // console.log('JB todoList', todoList);
                store.commit('setTodos', todoList);
            });
        },
        addTask(date, order, title, cb) {
            var d = new Date(
                date.toString().substring(0, 4),
                date.toString().substring(4, 6) - 1,
                date.toString().substring(6, 8)
            );
            d.setHours(0, 0, 0, 0);

            const batch = db.batch();

            // Reset order
            const userId = store.state.user.uid;
            const idList = store.state.todos.todos
                .filter(x => x.currentDateNumber === date)
                .sort((a, b) => a.order - b.order)
                .map(x => x.id);

            // Get category
            const selectedCategory = store.state.todos.selectedCategory;
            let categoryDocRef = null;
            if (selectedCategory) {
                categoryDocRef = db
                    .collection('user')
                    .doc(userId)
                    .collection('categories')
                    .doc(selectedCategory);
            }

            const newIdList = [...idList.slice(0, order).map(() => null), null, ...idList.slice(order)];

            // Add new task
            var newTaskRef = db
                .collection('user')
                .doc(userId)
                .collection('todos')
                .doc();
            batch.set(newTaskRef, {
                title: title,
                current_date: d,
                created_at: new Date(),
                updated_at: null,
                deleted_at: null,
                isDone: false,
                category: categoryDocRef,
                order,
            });

            const newCallback = () => cb(newTaskRef);
            this.resetOrder(newIdList, batch, newCallback);
        },
        resetOrder(ids, firestoreBatch, cb) {
            const batch = firestoreBatch ? firestoreBatch : db.batch();
            ids.forEach((id, i) => {
                // ignore null
                if (!id) return;

                var docRef = db
                    .collection('user')
                    .doc(store.state.user.uid)
                    .collection('todos')
                    .doc(id);

                batch.update(docRef, { order: i });
            });
            batch.commit().then(function() {
                if (typeof cb === 'function') {
                    cb();
                }
            });
        },
        updateTaskOrder(date, id, order) {
            db.collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id)
                .update({
                    order,
                });
        },
        setTaskTitle(id, title) {
            var d = new Date();

            db.collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id)
                .update({
                    title,
                    updated_at: d,
                });
        },
        toggleIsDone(id, isDone) {
            db.collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id)
                .update({
                    isDone,
                });
        },
        setTaskCurrentDate(date, id) {
            var d = new Date(
                date.toString().substring(0, 4),
                date.toString().substring(4, 6) - 1,
                date.toString().substring(6, 8)
            );
            d.setHours(0, 0, 0, 0);

            db.collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id)
                .update({
                    current_date: d,
                });
        },
        setTaskContents(id, contents) {
            db.collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id)
                .update({
                    contents,
                });
        },
        deleteTask(date, id) {
            const batch = db.batch();

            // Remove task
            const docRef = db
                .collection('user')
                .doc(store.state.user.uid)
                .collection('todos')
                .doc(id);

            batch.update(docRef, {
                deleted_at: firebase.firestore.Timestamp.fromDate(new Date()),
            });

            // Reset order
            const currentOrder = store.state.todos.todos.find(x => x.currentDateNumber === date && x.id === id).order;
            const idList = store.state.todos.todos
                .filter(x => x.currentDateNumber === date && x.id !== id)
                .sort((a, b) => a.order - b.order)
                .map(x => (x.order > currentOrder ? x.id : null));

            this.resetOrder(idList, batch);
        },
    },
};
